// @ts-nocheck
import React, { useState } from 'react';
import { sx } from '../sx';

const BTN = 'flex:none;height:28px;padding:0 12px;border-radius:999px;font-family:inherit;font-size:12px;cursor:pointer';

export default function CohortReviewCard({ r }: { r: any }) {
  const [changing, setChanging] = useState(false);
  const [value, setValue] = useState(r ? r.valueText : '');
  if (!r) return null;
  return (
    <div data-pop="review" role="dialog" aria-label={'Review ' + r.title} data-testid="cohort-review-card" style={sx(`position:absolute;top:12px;right:12px;z-index:45;width:340px;max-height:calc(100% - 24px);overflow:auto;padding:14px;border:1px solid #DCE4F2;border-radius:12px;background:#fff;box-shadow:0 30px 50px -25px rgba(8,35,76,0.35)`)}>
      <div style={sx(`display:flex;align-items:baseline;gap:8px`)}>
        <span style={sx(`flex:1;font-size:12.5px;font-weight:600;color:var(--ink)`)}>{r.title}</span>
        <span style={sx(`flex:none;font-size:13px;font-weight:600;font-variant-numeric:tabular-nums;color:${r.accepted ? '#0F7A55' : '#B42318'}`)}>{r.value}</span>
      </div>
      <div style={sx(`display:flex;flex-direction:column;gap:4px;margin-top:8px`)}>
        {(r.rules || []).map((l, i) => (
          <div key={i} style={sx(`font-size:11.5px;line-height:1.4;color:var(--ink-2)`)}>
            <span style={sx(`font-weight:500;color:#B42318`)}>{l.label}</span> · {l.text}
          </div>
        ))}
      </div>
      {r.trace ? (
        <div style={sx(`margin-top:10px;padding:8px 10px;border-radius:8px;background:#F7FAFD`)}>
          <div style={sx(`font-size:11px;font-weight:500;color:var(--ink-3)`)}>{r.trace.title}</div>
          {(r.trace.rows || []).map((row, i) => (
            <div key={i} style={sx(`display:flex;gap:8px;font-size:11px;color:var(--ink-2);line-height:1.5`)}>
              <span style={sx('flex:1;min-width:0')}>{row.label}</span>
              <span style={sx('flex:none;font-variant-numeric:tabular-nums')}>{row.value}</span>
            </div>
          ))}
          {(r.trace.steps || []).map((s, i) => (
            <div key={i} style={sx(`font-size:11px;color:var(--ink-3);line-height:1.5`)}>{s}</div>
          ))}
        </div>
      ) : null}
      {r.acceptedText ? <p data-testid="cohort-review-status" style={sx(`margin:10px 0 0;font-size:11.5px;line-height:1.45;color:${r.accepted ? '#0F7A55' : '#B42318'}`)}>{r.acceptedText}</p> : null}
      {changing ? (
        <div style={sx(`margin-top:10px;display:flex;align-items:center;gap:6px`)}>
          <input aria-label="New rate" value={value} onChange={e => setValue(e.target.value)} style={sx(`flex:1;min-width:0;height:28px;padding:0 8px;border:1px solid #C8D4EA;border-radius:8px;font-family:inherit;font-size:12px;text-align:right;outline:none`)} />
          <span style={sx(`flex:none;font-size:12px;color:var(--ink-3)`)}>%</span>
          <button type="button" onClick={() => setChanging(false)} style={sx(`${BTN};border:1px solid #C8D4EA;background:#fff;color:var(--ink-3)`)}>Back</button>
          <button type="button" data-testid="cohort-review-change-confirm" onClick={() => r.onChange(value)} style={sx(`${BTN};border:none;background:#0052CD;color:#fff`)}>Set value</button>
        </div>
      ) : (
        <div style={sx(`display:flex;justify-content:flex-end;flex-wrap:wrap;gap:6px;margin-top:12px`)}>
          <button type="button" onClick={r.onCancel} style={sx(`${BTN};border:1px solid #C8D4EA;background:#fff;color:var(--ink-3)`)}>Cancel</button>
          {r.onReopen ? <button type="button" onClick={r.onReopen} style={sx(`${BTN};border:1px solid #B42318;background:#fff;color:#B42318`)}>Reopen</button> : null}
          {r.canChange ? <button type="button" data-testid="cohort-review-change" onClick={() => setChanging(true)} style={sx(`${BTN};border:1px solid #0052CD;background:#fff;color:#0052CD`)}>Change value</button> : null}
          {r.canAccept ? <button type="button" data-testid="cohort-review-accept" onClick={() => r.onAccept()} style={sx(`${BTN};border:none;background:#0052CD;color:#fff`)}>Accept</button> : null}
        </div>
      )}
    </div>
  );
}
